var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vx-assistive-text"},[_c('div',{staticClass:"assistive-text",attrs:{"aria-live":_vm.ariaLive,"aria-relevant":"additions"}},[_vm._t("announce"),_vm._v(" "),_vm._l((_vm.textToRead),function(text,index){return _c('div',{key:index},[_vm._v(_vm._s(text))])})],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-566abc77","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/components/common/vx-assistive-text/vx-assistive-text.html
// module id = null
// module chunks = 